import LTR from "@brand-icons/global/pin-sensorial-experience-active/pin-sensorial-experience-active-ltr.svg";

import { iconFactory } from "../iconFactory";

export const PinSensorialExperienceActiveIcon = iconFactory("PinSensorialExperienceActiveIcon", LTR);
